///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.price_change_suppliers = abcsetup.price_change_suppliers || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.price_change_suppliers = {    
    init: function() {
        abcsetup.setTitle('Manage Price Change Suppliers');

        // Delete button clicked
        $(document).on('click', '.btn-delete', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Price Change Suppier', 'Are you sure you want to delete this price change suppier?', function (resp) {
                if (resp) {
                    window.location.href='/price_change_suppliers/delete/' + _this.data('id');
                }
            });

            return false;
        });

        // Init datatables
        abcsetup.datatables.init($('table#price_change_suppliers'), {
            bInfo: true,
            "responsive": true,
            "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
            "iDisplayLength": 10,
            "order": [[1, "asc"]],
            "columnDefs": [{
                "targets": 4,
                "orderable": false
            }],

            // "add" button params
            "addBtnModal": '#upload-modal',
            "addText": '<i class="fas fa-file-upload mr-1"></i> Import Supplier List',
        });        
    }
}
